import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Redirect, useHistory } from 'react-router-dom';

import Toasten from '../../../shared/components/Common/Toasten';
import FixedProcessLoader from '../../../shared/components/FixedProcessLoader';

import ProcessLoader from '../../../shared/components/process-loader/process-loader';

import { getModeType } from '../../../modules/merchants/store/actions/action.creators';
import TopNav from './Header/TopNav';
import SideBar from './Sidebar/SideBar';
import { setSuccess, setToggle } from '../../../store/action';
import { detectStateChange } from '../../../shared/helpers/stateChange';
import { FallbackPageWrapper } from 'react-current-page-fallback';

const DashboardContainer = props => {
    const history = useHistory();
    const { isToggled, success } = useSelector(({ Util }) => Util);
    const { modeTypeFetching } = useSelector(({ Merchants }) => Merchants);

    const {
        merchantDetails,
        kycStatus,
        merchantProfile: { merchantCategory, id },
        toggledAppMode
    } = useSelector(({ Merchants }) => Merchants);

    const [state, setState] = useState({
        isToggled: false,
        isSwitched: false,
        isDispatched: false
    });

    const dispatch = useDispatch();

    useEffect(() => {
        let merchantDetailsId =
            merchantDetails[0]?.id === undefined || merchantDetails[0]?.id === null ? 'SameId' : merchantDetails[0]?.id;
        let merchantProfileId = id === undefined || id === null ? 'NotSameId' : id;
        if (detectStateChange(merchantDetailsId, merchantProfileId)) {
            dispatch(getModeType());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const setSwitch = () => {
        setState({ isSwitched: !state.isSwitched, ...state });
    };

    const handleToggle = () => {
        dispatch(setToggle());
    };

    const handleCloseSucces = () => {
        dispatch(setSuccess(''));
    };

    const navListClickClose = () => {
        if (isToggled) dispatch(setToggle());
    };

    const { isSwitched } = state;
    const { pathname } = history.location;
    if (merchantDetails.length === 0 || kycStatus.BUSINESS_DETAILS === undefined) return <ProcessLoader />;

    return (
        <React.Fragment>
            <FallbackPageWrapper>
                <Toasten type="success" message={success} handleToastClose={handleCloseSucces} />

                {kycStatus.BUSINESS_DETAILS.kycStatus === 'PENDING_MERCHANT_SUBMISSION' && (
                    <Redirect to="/onboarding" />
                )}
                <div className={`oi-dashboard ${isToggled ? 'oi-dashboard--sidebar-compact' : ''}`}>
                    {!!modeTypeFetching && <FixedProcessLoader />}
                    <SideBar
                        isToggled={isToggled}
                        setToggle={handleToggle}
                        isSwitched={isSwitched}
                        setSwitch={setSwitch}
                        merchantDetails={merchantDetails}
                        // first access user wont see all the menu at their initial state
                        firstAccess={kycStatus?.BUSINESS_DETAILS?.kycStatus === 'PENDING_MERCHANT_SUBMISSION'}
                        onNavListCloser={navListClickClose}
                    />
                    {/* Hide the main top bar if the url is not add - business */}

                    <div
                        className={
                            isToggled ? 'oi-dashboard__width-compact' : 'oi-dashboard__width-resize'
                        }>
                        {pathname !== '/add-business' && (
                            <TopNav
                                isToggled={isToggled}
                                isSwitched={isSwitched}
                                setSwitch={setSwitch}
                                merchantCategory={merchantCategory}
                                toggledAppMode={toggledAppMode}
                            />
                        )}
                        {props.children}
                    </div>
                </div>
            </FallbackPageWrapper>
        </React.Fragment>
    );
};

export default DashboardContainer;
